import { get } from 'lodash';

import { Thesaurus } from '@skinsoft/types';

export const identifer = (thesaurus: Thesaurus): string => {
    return get(thesaurus, 'thesaurusCS.identifier.value', null) ?? // .value when it comes from elastic
        get(thesaurus, 'thesaurusCS.identifier', null)
}
